import axionIns from "../axios";

const getTermsAndPrivacy = async (type) => {
  var url = `admin/pagecontent?type=${type ? type : ''}`;
  return axionIns.get(url).then((response) => { return response.data; });
};
const addTermsAndPrivacy = async (payload) => {
  return axionIns
    .put("admin/pagecontent", JSON.stringify(payload)).then((response) => {
      return response.data;
    });
};

let exportObj = {
  getTermsAndPrivacy,
  addTermsAndPrivacy,
};

export default exportObj;
